import React, {FC} from 'react';
import Button from 'components/Button';
import {Handlers} from 'components/ContentPagesComponents/VoiceAgent/reducer';

import * as styles from './styles.module.scss';

type FooterProps = {
	report: string
	handlers: Handlers
}

export const Footer: FC<FooterProps> = ({report, handlers}) => {
	if (!report) {
		return (
			<Button
				className={styles.mobile}
				variant='light'
				disabled
			>
				Loading report...
			</Button>
		);
	}

	return (
		<>
			<Button
				className={styles.mobile}
				variant='light'
				onClick={handlers.toggleOverlay}
			>
				Open report
			</Button>
			<Button
				className={styles.desktop}
				variant='underline'
				onClick={handlers.toggleOverlay}
			>
				Expand your report in an overlay
			</Button>
		</>
	);
};
